/**
 * Allowed-domain normalization for embeddable widgets (SA-353).
 *
 * The TS twin of `backend/app/middleware/widget_cors.py::_normalize_domain`.
 * The middleware reduces a request Origin to a bare `host[:port]` and matches
 * it against the stored `allowed_domains`; normalizing at save time means the
 * admin sees exactly the value that will be matched. Keep the two in lockstep —
 * the test table is shared with the backend's.
 */

export function normalizeAllowedDomain(entry: string | null | undefined): string {
  if (!entry) return ''
  let value = entry.trim()
  const schemeAt = value.indexOf('://')
  if (schemeAt !== -1) value = value.slice(schemeAt + 3)
  // Drop anything after the host: path, query, fragment.
  for (const sep of ['/', '?', '#']) {
    const at = value.indexOf(sep)
    if (at !== -1) value = value.slice(0, at)
  }
  return value.toLowerCase()
}

export function normalizeAllowedDomains(entries: string[]): string[] {
  const out: string[] = []
  for (const raw of entries) {
    const domain = normalizeAllowedDomain(raw)
    if (domain && !out.includes(domain)) out.push(domain)
  }
  return out
}

export function parseAllowedDomains(text: string): string[] {
  return normalizeAllowedDomains(text.split('\n'))
}
